
import {
  ADD_PURCHASED_STOCK,
  SET_PURCHASED_STOCKS,
  CLEAR_PURCHASED_STOCKS,
  REMOVE_PURCHASED_STOCK,
  Strategy,
  PurchasedStock,
  AddPurchasedStockAction,
  SetPurchasedStocksAction,
  ClearPurchasedStocksAction,
  RemovePurchasedStockAction,
} from "../Reducers/types";

export const addPurchasedStock = (
  strategy: Strategy,
  stock: PurchasedStock
): AddPurchasedStockAction => ({
  type: ADD_PURCHASED_STOCK,
  payload: { strategy, stock },
});

export const setPurchasedStocks = (
  strategy: Strategy,
  stocks: PurchasedStock[]
): SetPurchasedStocksAction => ({
  type: SET_PURCHASED_STOCKS,
  payload: { strategy, stocks },
});

export const clearPurchasedStocks = (
  strategy: Strategy
): ClearPurchasedStocksAction => ({
  type: CLEAR_PURCHASED_STOCKS,
  payload: { strategy },
});

export const removePurchasedStock = (
  strategy: Strategy,
  symbol: string
): RemovePurchasedStockAction => ({
  type: REMOVE_PURCHASED_STOCK,
  payload: { strategy, symbol },
});
